import { useTranslation } from 'react-i18next';

import { normalizeMessage } from '../actions';
import { useWidgetContext } from 'widget/widget-context';
import { WIDGET_URL } from 'widget/constants/widget-url';
import * as Env from 'widget/env';

const userpic = `${WIDGET_URL}/static/img/bot.svg`;

const useAwayMessages = (): Env.Message[] => {
  const { widget } = useWidgetContext();
  const { t } = useTranslation();

  const name = t`Bot`;

  const messages = [
    normalizeMessage(t`Hello!`, name, userpic),
    normalizeMessage(
      widget.unavailable_text ||
        t`Sorry, our managers are currently unavailable.`,
      name,
      userpic,
    ),
  ];

  return messages;
};

export default useAwayMessages;
